import {ChangeDetectorRef, Component, OnDestroy, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IonInput, ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {MapsUtils} from 'src/maps/utils/maps';
import {Api} from 'src/smoothr-web-app-core/api/api';
import Address from 'src/smoothr-web-app-core/models/Address';
import NominatimAddress from 'src/smoothr-web-app-core/models/NominatimAddress';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {sleep} from 'src/smoothr-web-app-core/utils/utils';
import AutocompletePrediction = google.maps.places.AutocompletePrediction;
import GeocoderResult = google.maps.GeocoderResult;

export enum AddressTypeEnum {
	STANDART,
	CUSTOM
}

@Component({
	selector: 'app-get-address-modal',
	templateUrl: './get-address-modal.component.html',
	styleUrls: ['./get-address-modal.component.scss']
})
export class GetAddressModalComponent implements OnDestroy {
	public selectedAddressType$ = new BehaviorSubject<AddressTypeEnum>(null);
	addressType = AddressTypeEnum;
	public addressForm: FormGroup;
	predictions: any[] = [];
	loadingAddress = false;
	searchTerm = '';
	standartAddress = '';
	geolocatedAddress = '';
	@ViewChild('inputId', {static: true})
	inputField: IonInput;
	@ViewChild('standartInput')
	standartInputField: IonInput;
	showPredictions = false;
	MapsUtils = MapsUtils;
	newAddress: Address = null;
	loading = false;
	private standartAutocomplete: Subscription = null;
	constructor(
		private modalCtrl: ModalController,
		public fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private repository: RepositoryService,
		private snackBar: MatSnackBar,
		private translate: TranslateService
	) {
		this.createAddressForm();
	}

	static async show(modalCtrl: ModalController): Promise<any | null> {
		const modal = await modalCtrl.create({
			component: GetAddressModalComponent,
			cssClass: 'show-select-adress',
			backdropDismiss: true,
			showBackdrop: true
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		await sleep(200);
		return result;
	}
	async changeAddressType(type: AddressTypeEnum) {
		this.predictions = [];
		this.selectedAddressType$.next(type);
		if (type !== AddressTypeEnum.STANDART) {
			this.standartAutocomplete?.unsubscribe();
			this.standartAutocomplete = null;
		}
		if (type === AddressTypeEnum.CUSTOM) {
			this.initAutocomplete();
		}
		if (type === AddressTypeEnum.STANDART) {
			try {
				this.loading = true;
				const result = await MapsUtils.getUserGeocode();
				// const addrees = MapsUtils.placeToAddress(result);
				await this.addStandartAddress(result);
				console.log(result);
			} catch (e) {
				console.log(e);
				this.loading = false;
			}
			// the field stays editable, so the user can also type an address by hand
			await this.initStandartAutocomplete();
		}
	}

	async initStandartAutocomplete() {
		this.standartAutocomplete?.unsubscribe();
		this.standartAutocomplete = null;
		this.cdr.detectChanges();
		await sleep(0);
		if (!this.standartInputField) {
			return;
		}
		this.standartAutocomplete = await MapsUtils.initAutocompleteGoogle(this.standartInputField, predictions => {
			// ignore the change event caused by filling in the geolocated address
			if (this.geolocatedAddress && this.standartAddress === this.geolocatedAddress) {
				this.geolocatedAddress = '';
				return;
			}
			this.newAddress = null;
			this.predictions = predictions;
			this.cdr.detectChanges();
		});
	}
	createAddressForm() {
		this.addressForm = this.fb.group({
			address: ['']
		});
	}
	selected() {}

	dismiss() {
		this.modalCtrl.dismiss();
		console.log('!!!');
	}

	async initAutocomplete() {
		// console.log(await MapsUtils.executeSearchGoogleSearch(this.inputField));
		await MapsUtils.initAutocompleteGoogle(
			this.inputField,
			predictions => {
				this.predictions = predictions;
				this.cdr.detectChanges();
				console.log(predictions);
			}
			// loading => (this.loadingAddress = loading)
		);
	}
	async loadPlaceFunc(prediction: AutocompletePrediction) {
		await this.fillInPlace(await MapsUtils.getPlaceGoogle(prediction.description));
		this.predictions = [];
		this.cdr.detectChanges();
	}
	async addStandartAddress(prediction: Address) {
		try {
			this.cdr.detectChanges();
			this.standartAddress = MapsUtils.checkAddress(prediction);
			this.geolocatedAddress = this.standartAddress;
			this.loading = false;
			this.newAddress = prediction;
		} catch (e) {
			console.error(e);
			this.snackBar.open('Sorry this address doesn`t exist', null, {
				duration: 3000
			});
			this.loading = false;
		}
	}
	async fillInPlace(addressInput: GeocoderResult) {
		try {
			const isStandart = this.selectedAddressType$.value === AddressTypeEnum.STANDART;
			const input = isStandart ? this.standartInputField : this.inputField;
			const address = await MapsUtils.fillInPlaceGoogle(this.translate, input, addressInput, term => {
				if (term) {
					if (isStandart) {
						this.standartAddress = term;
					} else {
						this.searchTerm = term;
					}
				}
				console.log('term', term);

				return isStandart ? this.standartAddress : this.searchTerm;
			});
			console.log('Fill address', address);
			this.newAddress = address;
			this.loading = false;
		} catch (e) {
			console.error(e);
			this.snackBar.open('Sorry this address doesn`t exist', null, {
				duration: 3000
			});
			this.loading = false;
		}
	}
	close() {
		this.repository.address.emit(this.newAddress);
		this.modalCtrl.dismiss(this.newAddress);
	}
	ngOnDestroy() {
		this.standartAutocomplete?.unsubscribe();
	}
	changeAddressText(prediction: Address) {
		return this.addressToString(prediction);
	}
	addressToString(address: Address): string {
		if (!address) {
			return '';
		}
		// if (address.displayName?.length > 0) {
		// 	return address.displayName;
		// }
		let title = '';
		if (address.street) {
			title += address.street;
		}
		if (address.number) {
			title += ' ' + address.number;
		}
		// if (title !== '' && (address.postalCode || address.city)) {
		// 	title += ',';
		// }
		if (address.postalCode) {
			if (title !== '') {
				title += ' ';
			}
			title += address.postalCode;
		}
		if (address.city) {
			if (title !== '') {
				title += ' ';
			}
			title += address.city;
		}

		return title;
	}
}
